// extracted by mini-css-extract-plugin
export var divider = "_4f-0";
export var dividerText = "_4f-1";